import { render, staticRenderFns } from "./orderSend.vue?vue&type=template&id=67d1cc00&scoped=true"
import script from "./orderSend.vue?vue&type=script&lang=js"
export * from "./orderSend.vue?vue&type=script&lang=js"
import style0 from "./orderSend.vue?vue&type=style&index=0&id=67d1cc00&prod&scoped=true&lang=css"
import style1 from "./orderSend.vue?vue&type=style&index=1&id=67d1cc00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d1cc00",
  null
  
)

export default component.exports